(function()
{
	"use strict";

	if(cm.Device.OS.iOS === true)
	{
		var WebAudioContext = window.AudioContext || window.webkitAudioContext;
		if (WebAudioContext)
		{
			try
			{
				var context = new WebAudioContext();
				var buffer = context.createBuffer(1, 1, 44100);
				var audioSource = context.createBufferSource();
				audioSource.buffer = buffer;
				audioSource.connect(context.destination);
				audioSource.start(0);
				audioSource.disconnect();
				if (context && context.close)
					context.close();
			}
			catch (e)
			{
				//Something changed in the iOS webview.
			}
		}
	}
})();